export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    PaymentsStyleApi: 'specs.events.ui.PaymentsStyleApi',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.
    SeatingApiUpdate: 'specs.events.ui.SeatingApiUpdate',
    SeatingApiUpdateBM: 'specs.events.ui.SeatingApiUpdateBM',
    DisableRicos: 'specs.events.ui.DisableRicos',
    SausageIntegration: 'specs.events.ui.SausageIntegration', // false 100%, 2024-11-08
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting', // English 100%, 2024-11-08
    AiAssistant: 'specs.events.ui.AiEventsAssistant',
    AiEventsAssistantV2: 'specs.events.ui.AiEventsAssistantV2',
    AiEventsQaAssistant: 'specs.events.ui.AiEventsQaAssistant',
    AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
    AiTicketsQaAssistant: 'specs.events.ui.AiTicketsQaAssistant',
    AiEventsListQaAssistant: 'specs.events.ui.AiEventsListQaAssistant',
    AiChangeEventTypeAssistant: 'specs.events.ui.AiChangeEventTypeAssistant',
    AiOnlineEventQaAssistant: 'specs.events.ui.AiOnlineEventQaAssistant',
    AiDetailsPageStyleQaAssistant: 'specs.events.ui.AiDetailsPageStyleQaAssistant',
    AiCheckInAppQaAssistant: 'specs.events.ui.AiCheckInAppQaAssistant',
    AiAddStaffMemberAssistant: 'specs.events.ui.AiAddStaffMemberAssistant',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    PlanTicketsDesign: 'specs.events.ui.PlanTicketsDesign',
    UpdateSettingsPanelIllustrations: 'specs.events.ui.UpdateSettingsPanelIllustrations',
    DisableMobileFontOverrides: 'specs.events.ui.DisableMobileFontOverrides',
    UpdateGuestEmail: 'specs.events.ui.UpdateGuestEmail',
    UseGuestsService: 'specs.events.ui.UseGuestsService', // false 100%, 2024-11-08
    AddEditRegistrationFormStep: 'specs.events.ui.AddEditRegistrationFormStep', // false 100%, 2024-11-08
    SettingsCheckoutFormContent: 'specs.events.ui.SettingsCheckoutFormContent',
    DelayedPayments: 'specs.events.ui.DelayedPaymentCapture',
    SeatCategoryAssignment: 'specs.events.ui.SeatCategoryAssignment',
    TicketDefinitionNamePrefilled: 'specs.events.ui.TicketDefinitionNamePrefilled',
    StudioCompatibilitySettingsPanels: 'specs.events.ui.StudioCompatibilitySettingsPanels',
    SeatingCardRedesign: 'specs.events.ui.SeatingCardRedesign',
    CssPerBreakpointIndications: 'specs.events.ui.CssPerBreakpointIndications',
    GiftCardsEntryPoint: 'specs.events.ui.GiftCardsEntryPoint',
    GiftCardsViewer: 'specs.events.ui.GiftCardsViewer',
    NewStaffPermissions: 'specs.events.ui.NewStaffPermissions',
    GiftCardsContentUpdates: 'specs.events.ui.GiftCardsContentUpdates',
    SeatSelectionAnnouncement: 'specs.seatings.ui.SeatSelectionAnnouncement',
    DisableLoginHandlerOnInit: 'specs.events.ui.DisableLoginHandlerOnInit',
    TicketErrorToasts: 'specs.events.ui.TicketErrorToasts',
    ListDateLocationFormatSetting: 'specs.events.ui.ListDateLocationFormatSetting',
    MigrateEmailsAutomation: 'specs.events.ui.MigrateEmailsAutomation',
    AiCopyTicketsAssistant: 'specs.events.ui.AiCopyTicketsAssistant',
    SkillTicketPolicy: 'specs.events.ui.SkillTicketPolicy',
    ImageRatioAssistant: 'specs.events.ui.ImageRatioAssistant',
    AiCreateCategoryAssistant: 'specs.events.ui.AiCreateCategoryAssistant',
    AiCategoriesQaAssistant: 'specs.events.ui.AiCategoriesQaAssistant',
    SkillMembershipsQA: 'specs.events.ui.SkillMembershipsQA',
    AiGuestsAndOrdersQaAssistant: 'specs.events.ui.AiGuestsAndOrdersQaAssistant',
    AiCreateScheduleItemAssistant: 'specs.events.ui.AiCreateScheduleItemAssistant',
    AiCreateRegistrationFormFieldAssistant: 'specs.events.ui.AiCreateRegistrationFormFieldAssistant',
    UpdatedCardsLayout: 'specs.events.ui.UpdatedCardsLayout',
    AiPromotionsAssistant: 'specs.events.ui.PromotionsAssistantQA',
    GuestManagement: 'specs.events.ui.GuestManagement',
    EditEventDetailsPageVisibility: 'specs.events.ui.EditEventDetailsPageVisibility',
    RsvpButtonContentUpdates: 'specs.events.ui.RsvpButtonContentUpdates',
    WidgetCountdownUpdates: 'specs.events.ui.WidgetCountdownUpdates',
    SkillSeatingQA: 'specs.seatings.ui.SkillSeatingQA',
    LiveVideoTerminated: 'specs.seatings.ui.LiveVideoTerminated',
    GetGoogleMapsMetaSiteFix: 'specs.events.ui.GetGoogleMapsMetaSiteFix',
    ConsentPolicy: 'specs.events.ui.ConsentPolicy',
    NewImageSettings: 'specs.events.ui.NewImageSettings',
    WidgetSpacingUpdates: 'specs.events.ui.WidgetSpacingUpdates',
    FixAddingAssignedGuests: 'specs.events.ui.FixAddingAssignedGuests',
    EventsListSeoPanel: 'specs.events.ui.EventsListSeoPanel',
    WidgetPaddingSettings: 'specs.events.ui.WidgetPaddingSettings',
};
//# sourceMappingURL=experiments.js.map